import "./ChipComponent.scss";

import React from 'react';
import {Chip} from "@mui/material";
import TooltipComponent from "../tooltip/tooltipComponent";

interface ChipComponentProps {
    label: any;
    size?: 'medium' | 'small' | undefined;
    classes?: object;
    className?: string;
    color?: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | undefined;
    disabled?: boolean;
    onDelete?: Function;
    onClick?: Function;
    variant?: 'filled' | 'outlined' | undefined;
    icon?: React.ReactElement;
    prefixIcon?:any;
}

const ChipComponent = (props: ChipComponentProps) => {

    const {label} = props;

    let {size, className, onClick, onDelete, color, icon, variant, disabled,prefixIcon} = props;
    if (!size) size = "medium";
    if (!color) color = "default";
    if (!variant) variant = "filled";
    if (props.className === 'draft') {
        color = "error";
    } else {
        color = "default";
    }


    return (
        <Chip
            label={
                label?.length > 15 ? <>
                    <TooltipComponent
                        tooltip={label}
                        placement={'bottom'}
                        arrow={true}>
                        <span>{label}</span>
                    </TooltipComponent>
                </> : label
            }
            size={size}
            color={color}
            icon={prefixIcon || icon}
            className={'chip ' + className}
            clickable={!!onClick}
            disabled={disabled}
            variant={variant}
            onClick={onClick && ((e: any) => {
                if (onClick) {
                    onClick(e);
                }
            })}
            onDelete={onDelete && ((e: any) => {
                if (onDelete) {
                    onDelete(e);
                }
            })}
        />
    )
};

export default ChipComponent;
